import logger from "../../../../utils/LoggerFrontend";

export async function notifyAddOnsOnSlack({
  Actions,
  userName,
  userId,
  email,
  orgaName,
  orgaId,
  campaignId,
  analysisOptimizationCost,
  analysisFeedbackCost,
  spotifyHumanVoiceCost
}) {
  const channel = email.includes("talentbait.com")
    ? "#video-review-activity-test"
    : "#video-review-activity";

  const cleanUserName = `<https://app.talentbait.de/admin/users/${userId}|${userName}>`;
  let message = `Booking Overview (Campaign Creation): ✅ ${cleanUserName} of <https://internal.talentbait.de/admin/organizations/${orgaId}|${orgaName}> created a campaign and selected the following video review options:\n`;

  if (analysisOptimizationCost > 0) {
    message += `\n- 💡 Optimize analysis (${analysisOptimizationCost} €)`;
  }

  if (analysisFeedbackCost > 0) {
    message += `\n- 📝 Feedback analysis (${analysisFeedbackCost} €)`;
  }

  if (spotifyHumanVoiceCost > 0) {
    message += `\n- 🎙️ Spotify Human Voice (${spotifyHumanVoiceCost} €)`;
  }

  message += `\n\nPlease review the campaign link here: <https://internal.talentbait.de/admin-campaign/${orgaId}/${campaignId}>`;

  logger.log("BookingOverview-VideoReview-slackMessage", "slack channel", { channel });

  logger.log("BookingOverview-VideoReview-slackMessage", "message composed", { message });

  Actions.sendSlackMessage({ message, channel });
}
